import {BonusPoints} from "./BonusPoints.js";


export class EmployeeBonusPoints {

  constructor(bonusPoints, orderTracking) {
    this.bonusPoints = bonusPoints;
    this.orderTracking = orderTracking;
  }

  registerRedeemClickHandler() {
    return window.o_util.event.delegate('.order_js_basket_or_checkout', "click", "#or_js_bonusPoints__checkbox",
      async (event) => {
        const input = event.target;
        const toBeRedeemed = input.checked ? input.dataset.redeemable : '0';
        await this.bonusPoints.redeemBonusPointsAndReload(toBeRedeemed)
          .catch(() => this._handleRedemptionError(input));
      });
  }

  _orderMessageFeature(errorMessageId) {
    return {
      id: 'order_message',
      name: 'OrderMessage',
      status: 'visible',
      labels: {
        order_ErrorMessage: [errorMessageId]
      }
    }
  }

  _handleRedemptionError(input) {
    this.bonusPoints.renderBonusPointRedemptionError();
    input.checked = !input.checked
    const checkboxContainer = document.getElementById('or_js_bonusPoints__checkboxContainer');
    if (!!checkboxContainer) {
      checkboxContainer.classList.add('pl_checkbox--invalid')
    }
    this.orderTracking.submitEvent({
      name: 'submit',
      features: [this._orderMessageFeature(BonusPoints.REDEMPTION_ERROR_MESSAGE_ID + '.checkbox')]
    })
  }

  static initialize(settingsService) {
    if (!!settingsService && typeof settingsService.isEnabled === 'function') {
      const bonusPoints = new BonusPoints();
      const employeeBonusPoints = new EmployeeBonusPoints(bonusPoints, window.o_order.tracking);

      window.o_global.eventLoader.onReady(100, () => {
        employeeBonusPoints.registerRedeemClickHandler();
      });
    }
  }
}
